import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { ActionIcons, ActionIconsBtn, IconRow, KeypadOption, Numbers } from '../styles/dialpadstyle';
import {
  FormWrapper,
  FormColumn,
  FormGroup,
  ControlLabel,
  FormControl
} from 'modules/theme';

export class DTMFTheme extends Component {
  constructor(props){
    super(props);
    this.numberList = [[1,2,3],[4,5,6],[7,8,9],["*",0,"#"]];
    this.renderDigit = this.renderDigit.bind(this);
    this.state = {
      "number" : ""
    }
  }
  renderFormGroup(label, props) {
    return (
      <FormGroup>
        {/* <ControlLabel required={props.required}>{label}</ControlLabel> */}
        <FormControl {...props} />
      </FormGroup>
    );
  }

  renderDigit() {
    const { onDtmfClick } = this.props;
    let _this = this;
    return this.numberList.map((element)=>{
      return (
        <IconRow>
          {
            element.map((digit, index)=>{
              return (
                <Numbers onClick={()=>{
                  _this.state.number += `${digit}`
                  _this.setState({"number": _this.state.number })
                  onDtmfClick(digit);
                }}>
                  <h6>{digit}</h6>
                </Numbers>
              )
            })
          }
        </IconRow>
      );
    })
  }
  render() {

    const { number, onBackBtn } = this.props;
    return (
      <KeypadOption>
        <form>
          <FormWrapper>
            {/* <FormColumn></FormColumn> */}
            <FormColumn>
              {this.renderFormGroup('', {
                type: 'text',
                disabled: true,
                defaultValue: '',
                placeholder: '',
                autoFocus: false,
                required: true,
                id: 'number',
                value: this.state.number,
              })}
            </FormColumn>
          </FormWrapper>
        </form>
        {
          this.renderDigit()
        }
        {/* {<div className="row" ><div className="col-md-12" ><a onClick={onBackBtn}>Back</a></div></div>} */}
      </KeypadOption>
    )
  }
}

DTMFTheme.propTypes = {
  isConnected: PropTypes.bool.isRequired
};

DTMFTheme.contextTypes = {
  __: PropTypes.func
};

export default DTMFTheme


// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/DTMFTheme.js